
import { store ,  defineJsongammesbulletins,} from "../state/redux";
import { queryClient } from '../state/queryClient';

import { axios_compagnies_getCourtierCompagniesDatas } from "../axios/axios_compagnies";


export const findCourtierCompagniesDatas = async()=>{ 
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
    let response = await axios_compagnies_getCourtierCompagniesDatas(user.courtier) ;
    const {jsongammesbulletins} = response.data ;
    store.dispatch(defineJsongammesbulletins(jsongammesbulletins)) ; 
}
